import { StatusRead } from '@app/generated'

export function sortStatuses(statuses: StatusRead[]) {
	return statuses.sort((a, b) => {
		const posA = a.position ?? Number.MAX_SAFE_INTEGER
		const posB = b.position ?? Number.MAX_SAFE_INTEGER

		if (posA !== posB) {
			return posA - posB
		}

		const dateA = a.created_at ? new Date(a.created_at).getTime() : 0
		const dateB = b.created_at ? new Date(b.created_at).getTime() : 0

		return dateA - dateB
	})
}
